
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(247|940)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
